
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire187a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire187a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $fmRoT = parcelRequire("fmRoT");
const $b63be9b0371e788c$var$baseAPI = "https://coelho-backend.herokuapp.com/api";
let $b63be9b0371e788c$var$submit = document.getElementById("Submit");
$b63be9b0371e788c$var$submit.addEventListener("click", $b63be9b0371e788c$var$login);
let $b63be9b0371e788c$var$userId = 0;
async function $b63be9b0371e788c$var$login() {
    let email = document.getElementById("email");
    let password = document.getElementById("password");
    let body = {
        "identifier": email.value,
        "password": password.value
    };
    console.log(body);
    let send = await (0, $fmRoT.default).post($b63be9b0371e788c$var$baseAPI + "/auth/local", body).catch((error)=>$b63be9b0371e788c$var$setFeedback(JSON.stringify(error)));
    localStorage.setItem("jwt", send.data.jwt);
    if (send.status == 200) {
        $b63be9b0371e788c$var$setFeedback("");
        document.getElementById("search").style.display = "flex";
        document.getElementById("login").style.display = "none";
    } else $b63be9b0371e788c$var$setFeedback(JSON.stringify(send));
    return false;
}
let $b63be9b0371e788c$var$check = document.getElementById("search-cpf");
$b63be9b0371e788c$var$check.addEventListener("click", $b63be9b0371e788c$var$checkUser);
let $b63be9b0371e788c$var$searchForm = document.getElementById("search-form");
$b63be9b0371e788c$var$searchForm.onsubmit = function() {
    $b63be9b0371e788c$var$checkUser();
    return false;
};
async function $b63be9b0371e788c$var$checkUser() {
    $b63be9b0371e788c$var$setFeedback("");
    document.getElementById("found-cpf").innerHTML = "";
    document.getElementById("found-name").innerHTML = "";
    document.getElementById("found-updated").innerHTML = "";
    document.getElementById("found-created").innerHTML = "";
    document.getElementById("found-validated").innerHTML = "";
    let cpf = document.getElementById("cpf");
    let jwt = localStorage.getItem("jwt");
    let headers = {
        "Authorization": "Bearer " + jwt
    };
    let send = await (0, $fmRoT.default).get($b63be9b0371e788c$var$baseAPI + "/codes?filters[code][$eq]=" + cpf.value, {
        headers: headers
    }).catch((error)=>$b63be9b0371e788c$var$setFeedback(JSON.stringify(error)));
    if (send.status == 200) {
        let userData = send.data.data;
        console.log(userData);
        if (userData.length > 0) {
            let c = new Date(userData[0].createdAt);
            let u = new Date(userData[0].updatedAt);
            $b63be9b0371e788c$var$userId = userData[0].documentId;
            document.getElementById("found-cpf").innerHTML = userData[0].code;
            document.getElementById("found-name").innerHTML = userData[0].name + " " + userData[0].surname;
            document.getElementById("found-updated").innerHTML = u;
            document.getElementById("found-created").innerHTML = c;
            document.getElementById("found-validated").innerHTML = userData[0].received ? "sim" : "n\xe3o";
            document.getElementById("validate").style.display = userData[0].received ? "none" : "block";
            document.getElementById("found-code").innerHTML = "Procurando c\xf3digo...";
        } else $b63be9b0371e788c$var$setFeedback("CPF n\xe3o encontrado");
    }
    return false;
}
let $b63be9b0371e788c$var$validate = document.getElementById("validate");
$b63be9b0371e788c$var$validate.addEventListener("click", $b63be9b0371e788c$var$validateUser);
async function $b63be9b0371e788c$var$validateUser() {
    $b63be9b0371e788c$var$setFeedback("");
    let jwt = localStorage.getItem("jwt");
    let headers = {
        "Authorization": "Bearer " + jwt
    };
    let send = await (0, $fmRoT.default).put($b63be9b0371e788c$var$baseAPI + "/codes/" + $b63be9b0371e788c$var$userId, {
        "data": {
            "received": true
        }
    }, {
        headers: headers
    }).catch((error)=>$b63be9b0371e788c$var$setFeedback(JSON.stringify(error)));
    if (send.status == 200) {
        document.getElementById("validate").style.display = "none";
        document.getElementById("found-validated").innerHTML = "True";
        $b63be9b0371e788c$var$setFeedback("Brinde validado");
    }
}
function $b63be9b0371e788c$var$setFeedback(message) {
    document.getElementById("feedback").innerHTML = message;
}


//# sourceMappingURL=index.e66a09d1.js.map
